var _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _line3, _line4, _line5, _line6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedsCitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.66 146.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.85,33.85c0-5.83,4.72-10.55,10.55-10.55h-51.17c-5.83,0-10.55,4.72-10.55,10.55h51.17Z",
    fill: "#4caf50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.95,112.36c0,5.83,4.72,10.55,10.55,10.55s10.55-4.72,10.55-10.55h-21.1Z",
    fill: "#4caf50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.85,33.85c0-5.83,4.72-10.55,10.55-10.55h-51.17c-5.83,0-10.55,4.72-10.55,10.55h51.17Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.95,112.36c0,5.83,4.72,10.55,10.55,10.55s10.55-4.72,10.55-10.55h-21.1Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.95,112.36c0,5.83,4.72,10.55,10.55,10.55H44.42c-5.83,0-10.55-4.72-10.55-10.55V33.85h43.98c0-5.82,4.72-10.55,10.55-10.55s10.55,4.72,10.55,10.55v78.51Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.95,33.85c0-5.83-4.72-10.55-10.55-10.55s-10.55,4.72-10.55,10.55h-43.98v78.51c0,5.82,4.72,10.55,10.55,10.55h65.08c-5.82,0-10.55-4.72-10.55-10.55V33.85Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48.68,
    y1: 50.4,
    x2: 63.64,
    y2: 50.4,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48.68,
    y1: 60.94,
    x2: 73.85,
    y2: 60.94,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 48.68,
    y1: 71.49,
    x2: 73.85,
    y2: 71.49,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 48.68,
    y1: 82.04,
    x2: 73.85,
    y2: 82.04,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 48.68,
    y1: 92.59,
    x2: 73.85,
    y2: 92.59,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 48.68,
    y1: 103.14,
    x2: 73.85,
    y2: 103.14,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5,54.42c7.35,7.36,8.41,18.62,3.18,27.11-.88,1.43-1.94,2.79-3.18,4.02-1.24,1.24-2.58,2.3-4.01,3.18-8.47,5.24-19.72,4.18-27.06-3.18-8.58-8.59-8.58-22.54,0-31.13,8.57-8.6,22.49-8.6,31.07,0",
    fill: "#70bf73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.45,96.15c1.01,1.02,1.53,2.36,1.53,3.69s-.52,2.67-1.53,3.69c-2.05,2.04-5.35,2.04-7.4,0l-14.25-14.29-.32-.51c1.43-.88,2.78-1.94,4.01-3.18,1.24-1.24,2.3-2.59,3.18-4.02l.52.33,14.26,14.29Z",
    fill: "#4caf50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.48,88.73c-8.47,5.24-19.72,4.18-27.06-3.18-8.58-8.59-8.58-22.54,0-31.13,8.57-8.6,22.49-8.6,31.07,0,7.35,7.36,8.41,18.62,3.18,27.11-.88,1.43-1.94,2.79-3.18,4.02-1.24,1.24-2.58,2.3-4.01,3.18Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M112.81,89.23l14.25,14.29c2.05,2.05,5.35,2.05,7.39.01,1.01-1.02,1.53-2.35,1.53-3.69s-.52-2.67-1.53-3.69l-14.26-14.29",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedsCitation);
export default __webpack_public_path__ + "static/media/needs-citation.d6c4eb069ebcc20d5e9b97edac328900.svg";
export { ForwardRef as ReactComponent };